var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DataRender',{staticClass:"DialogExpressInfo",attrs:{"onLoad":_vm.handleLoad}},[_c('el-timeline',_vm._l((_vm.info.list),function(v,index){return _c('el-timeline-item',{key:index,attrs:{"timestamp":v.time}},[_vm._v(" "+_vm._s(v.content)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }